import React, { Component } from 'react'

import Carousel from 'react-bootstrap/Carousel'

class ATCCarousel extends Component {
    constructor(props, context) {
      super(props, context);
  
      this.handleSelect = this.handleSelect.bind(this);
  
      this.state = {
        index: 0,
        direction: null,
        categories: {
            "Gardens": {
                full: "https://res.cloudinary.com/threesix/image/upload/v1552245689/atcgardening/home/Garden_home.jpg",
                max: "https://res.cloudinary.com/threesix/image/upload/v1552245689/atcgardening/home/Garden_home.jpg",
                mid: "https://res.cloudinary.com/threesix/image/upload/h_500/v1552245689/atcgardening/home/Garden_home.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552245689/atcgardening/home/Garden_home.jpg",
            },
            "Fencing and Decking": {
                full: "https://res.cloudinary.com/threesix/image/upload/w_1200,ar_16:9/v1552245053/atcgardening/home/fencing-and-decking-home.jpg",
                max: "https://res.cloudinary.com/threesix/image/upload/v1552245053/atcgardening/home/fencing-and-decking-home.jpg",
                mid: "https://res.cloudinary.com/threesix/image/upload/h_500/v1552245053/atcgardening/home/fencing-and-decking-home.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552245053/atcgardening/home/fencing-and-decking-home.jpg",
            },
            "Landscaping": {
                full: "https://res.cloudinary.com/threesix/image/upload/w_1200,ar_16:9/v1552245054/atcgardening/home/Landscape_home_photo.jpg",
                max: "https://res.cloudinary.com/threesix/image/upload/v1552245054/atcgardening/home/Landscape_home_photo.jpg",
                mid: "https://res.cloudinary.com/threesix/image/upload/h_500/v1552245054/atcgardening/home/Landscape_home_photo.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552245054/atcgardening/home/Landscape_home_photo.jpg",
            },
            "Garden buildings": {
                full: "https://res.cloudinary.com/threesix/image/upload/w_1200,ar_16:9/v1552245053/atcgardening/home/Garden_buildings_Home_photo.jpg",
                max: "https://res.cloudinary.com/threesix/image/upload/v1552245053/atcgardening/home/Garden_buildings_Home_photo.jpg",
                mid: "https://res.cloudinary.com/threesix/image/upload/h_500/v1552245053/atcgardening/home/Garden_buildings_Home_photo.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552245053/atcgardening/home/Garden_buildings_Home_photo.jpg",
            },
            "Garages": {
                full: "https://res.cloudinary.com/threesix/image/upload/c_fill,g_south,h_600,w_1200/v1552246252/atcgardening/home/Garages_Home_picture.jpg",
                max: "https://res.cloudinary.com/threesix/image/upload/c_600,w_1200/v1552246252/atcgardening/home/Garages_Home_picture.jpg",
                mid: "https://res.cloudinary.com/threesix/image/upload/h_500/v1552246252/atcgardening/home/Garages_Home_picture.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552246252/atcgardening/home/Garages_Home_picture.jpg",
            },
            "Kids Zone": {
                full: "https://res.cloudinary.com/threesix/image/upload/w_1200,ar_16:9/v1552245057/atcgardening/home/kid_zone_home.jpg",
                max: "https://res.cloudinary.com/threesix/image/upload/v1552245057/atcgardening/home/kid_zone_home.jpg",
                mid: "https://res.cloudinary.com/threesix/image/upload/h_500/v1552245057/atcgardening/home/kid_zone_home.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552245057/atcgardening/home/kid_zone_home.jpg",
            },
            "Pet Zone": {
                full: "https://res.cloudinary.com/threesix/image/upload/v1552246663/atcgardening/home/pet_zone_home_picture.jpg",
                max: "https://res.cloudinary.com/threesix/image/upload/v1552246663ome/pet_zone_home_picture.jpg",
                mid: "https://res.cloudinary.com/threesix/image/upload/h_500/v1552246663/atcgardening/home/pet_zone_home_picture.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552246663/atcgardening/home/pet_zone_home_picture.jpg",
            },
        }
      };
    }
  
    handleSelect(selectedIndex, e) {
      this.setState({
        index: selectedIndex,
        direction: e.direction,
      });
    }
  
    render() {
      const { index, direction } = this.state;
  
      return (
        <div>
            <Carousel
            activeIndex={index}
            direction={direction}
            onSelect={this.handleSelect}
            className="fullCarous"
            >
                {Object.keys(this.state.categories).map(cat => <Carousel.Item key={cat + 'full'}>
                    <img
                        src={this.state.categories[cat].full}
                        alt={cat}
                        className="carouselImg"
                    />
                    <Carousel.Caption>
                        <h2 className="carouselCaption">{cat.toUpperCase()}</h2>
                    </Carousel.Caption>
                </Carousel.Item>)}
            </Carousel>
            <Carousel
            activeIndex={index}
            direction={direction}
            onSelect={this.handleSelect}
            className="midCarous"
            >
                {Object.keys(this.state.categories).map(cat => <Carousel.Item key={cat + 'mid'}>
                    <img
                        src={this.state.categories[cat].mid}
                        alt={cat}
                        className="carouselImg"
                    />
                    <Carousel.Caption>
                        <h2 className="carouselCaption">{cat.toUpperCase()}</h2>
                    </Carousel.Caption>
                </Carousel.Item>)}
            </Carousel>
            <Carousel
            activeIndex={index}
            direction={direction}
            onSelect={this.handleSelect}
            className="mobileCarous"
            >
                {Object.keys(this.state.categories).map(cat => <Carousel.Item key={cat + 'mobile'}>
                    <img
                        src={this.state.categories[cat].mobile}
                        alt={cat}
                        className="carouselImg"
                    />
                    <Carousel.Caption>
                        <h2>{cat}</h2>
                    </Carousel.Caption>
                </Carousel.Item>)}
            </Carousel>
        </div>
      );
    }
  }
  
  export default ATCCarousel


// WEBPACK FOOTER //
// ./src/components/Carousel.jsx